import { ContactDetail } from '.';

const Validations = {
  Email: {
    Required: {
      text: 'Email is Required',
    },
    Invalid: {
      text: 'Invalid email address',
    },
  },
  Phone: {
    Required: {
      text: 'Phone is Required',
    },
    Invalid: {
      text: 'Invalid phone format',
    },
  },
};

export const validateBasicDetails = (values:ContactDetail):
  ContactDetail => {
  const errors: ContactDetail = {} as ContactDetail;
  // const phoneNumber = /^\d+$/;

  if (values.emails) {
    values.emails.forEach(({ id, value }) => {
      if (!value) {
        if (errors.emails) {
          errors.emails = [
            ...errors.emails,
            {
              id,
              value: Validations.Email.Required.text,
            },
          ];
        } else {
          errors.emails = [
            {
              id,
              value: Validations.Email.Required.text,
            },
          ];
        }
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
      ) {
        if (errors.emails) {
          errors.emails = [
            ...errors.emails,
            {
              id,
              value: Validations.Email.Invalid.text,
            },
          ];
        } else {
          errors.emails = [
            {
              id,
              value: Validations.Email.Invalid.text,
            },
          ];
        }
      }
    });
  }

  if (values.phones) {
    values.phones.forEach(({ id, value }) => {
      if (!value) {
        if (errors.phones) {
          errors.phones = [
            ...errors.phones,
            {
              id,
              value: Validations.Phone.Required.text,
            },
          ];
        } else {
          errors.phones = [
            {
              id,
              value: Validations.Phone.Required.text,
            },
          ];
        }
      }

      // Matan commented next lines out because the server doesn't support a specifc format.
      // mutliple phone numbers formats can be received from the server...
      
      // else if (
      //   !value.match(phoneNumber)
      // ) {
      //   if (errors.phones) {
      //     errors.phones = [
      //       ...errors.phones,
      //       {
      //         id,
      //         value: Validations.Phone.Invalid.text,
      //       },
      //     ];
      //   } else {
      //     errors.phones = [
      //       {
      //         id,
      //         value: Validations.Phone.Invalid.text,
      //       },
      //     ];
      //   }
      // }
    });
  }

  return errors;
};
